const log = {
  debug: (message: string, ...data: unknown[]) => {
    console.debug(message, ...data);
  },
  info: (message: string, ...data: unknown[]) => {
    console.info(message, ...data);
  },
  warn: (message: string, ...data: unknown[]) => {
    console.warn(message, ...data);
  },
  error: (message: unknown, ...data: unknown[]) => {
    console.error(message, ...data);
  },
};

export default log;
